
import React, { useEffect, useState } from 'react';
import {
  useQueryClient,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import axios from 'axios';
import Dashboard from './Dashboard';
import Loading from './Loading';
import { useNavigate } from 'react-router-dom'
import { adminapi } from '../axios'


const AdminLogin = () => {
  const [mydata, setmydata] = useState(localStorage?.getItem("admin")) || {};
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [input, setInput] = useState({})
  const [err, setErr] = useState('')
  const [idata, setIData] = useState({})

  const handleInput = (e) => {
    setInput({ ...input, [e.target.id]: e.target.value })
  }

  const { isPending, error, data: adminslist } = useQuery({
    queryKey: ['admins'],
    queryFn: async () => {
      try {
        const datas = await axios.get(adminapi);
        return datas?.data;
      } catch (error) {
        console.error('Error fetching admins:', error);
        throw error;
      }
    },
  });


  const { mutate: getLogin, isPending: gettingLoggedIn } = useMutation({
    mutationKey: ['login'],
    mutationFn: async () => await fetch(`${adminapi}?user=${input?.user}&password=${input?.password}`).then(r => r.json()),
    onSuccess: (data) => {
      if (!!data?.id === true) {
        console.log(data)
        setIData(data);
        localStorage.setItem('admin', JSON.stringify(data));
        setIsLoggedIn(true);
        navigate('/dashboard')
        // queryClient.invalidateQueries(['admins']);
      }
      else {
        console.log("no student with given id found")
        setErr("no student with given id found");
        return ("no student with given id found");
      }

    },
    onError: (error) => {
      console.error('Error fetching admins:', error);
    },
  });


  const handleLogin = () => {
    //console.log(input);
    getLogin()
  };

  if (isPending) return <Loading />;

  if (isLoggedIn && !!mydata) return <Dashboard login={setIsLoggedIn} />

  return (
    <div className='m-auto h-auto pt-8'>
      {/* {JSON.stringify(mydata)} */}
      <div className="max-w-md w-4/5 mx-auto p-6 bg-black rounded-md shadow-md">
        <h2 className="text-2xl font-semibold mb-6 text-white">Admin Login { }</h2>
        <div className="mb-4">
          <label htmlFor="admin" className="block text-gray-100 text-sm font-bold mb-2">
            Managed By:
          </label>
          <select
            id="user"
            name="user"
            className="w-full p-2 border rounded text-black"
            value={input["user"]}
            onChange={handleInput}
          >
            <option value="">choose</option>
            {adminslist &&
              adminslist.map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
          </select>
        </div>

        <div className="mb-4 ">
          <label htmlFor="nid" className="block text-gray-100 text-sm font-bold mb-2">
            Password:
          </label>
          <input
            type="password"
            id="password"
            name="password"
            className="w-full p-2 border rounded text-black"
            onChange={handleInput}
          />
        </div>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        <button
          type="button"
          onClick={handleLogin}
          className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
        >
          Login
        </button>
        <span className='text-red-700 ml-5'>{err && err}</span>
        {gettingLoggedIn && <div className='text-center m-2'><Loading /></div>}
      </div>
    </div>
  );
};

export default AdminLogin;
